export default __webpack_public_path__ + "static/media/svg-3.92e64eb1.svg";